export default "__VITE_ASSET__c4d6e3f7__"